// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  background-color: #fbecfb;
  height: -webkit-fill-available;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.rbc-timeslot-group {
  min-height: 200px;
}

.bg-light-pink { background-color: #fddefd !important; }
.bg-medium-pink { background-color: #fd78ff !important; }
.bg-dark-pink { background-color: #d354f3 !important; }
.bg-very-dark-pink { background-color: #84369c !important; }
.nc-text-primary { background-color: rgba(233, 146, 255, 0.7); color: black; }
.nc-text-secondary { color: white; }
.nav-link-text { color: rgb(0, 59, 18) !important; }
.nc-background { background-image: linear-gradient(270deg, #cd89da 0%, #c555bc 70%) !important; }
.section { scroll-margin-top: 100px; }
.first-section { scroll-margin-top: 130px; }
.first-section-margin-bottom { margin-bottom: 1300px;}
.show-description { display: none !important; }
.nc-event {background-color: #d354f3 !important; font-size: 12px !important; color: white;}
.nc-event h4 {font-size: 12px !important; color: white;}
.nc-event a:visited { color: black; }
.nc-event a:active { color: black;}
.carousel-img { max-height: 200px; max-width: 100%; width: auto !important; display: inline !important; }
.item {text-align: center;}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB,oCAAoC,EAAE;AACvD,kBAAkB,oCAAoC,EAAE;AACxD,gBAAgB,oCAAoC,EAAE;AACtD,qBAAqB,oCAAoC,EAAE;AAC3D,mBAAmB,0CAA0C,EAAE,YAAY,EAAE;AAC7E,qBAAqB,YAAY,EAAE;AACnC,iBAAiB,gCAAgC,EAAE;AACnD,iBAAiB,6EAA6E,EAAE;AAChG,WAAW,wBAAwB,EAAE;AACrC,iBAAiB,wBAAwB,EAAE;AAC3C,+BAA+B,qBAAqB,CAAC;AACrD,oBAAoB,wBAAwB,EAAE;AAC9C,WAAW,oCAAoC,EAAE,0BAA0B,EAAE,YAAY,CAAC;AAC1F,cAAc,0BAA0B,EAAE,YAAY,CAAC;AACvD,sBAAsB,YAAY,EAAE;AACpC,qBAAqB,YAAY,CAAC;AAClC,gBAAgB,iBAAiB,EAAE,eAAe,EAAE,sBAAsB,EAAE,0BAA0B,EAAE;AACxG,OAAO,kBAAkB,CAAC","sourcesContent":[".App {\n  text-align: center;\n  background-color: #fbecfb;\n  height: -webkit-fill-available;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.rbc-timeslot-group {\n  min-height: 200px;\n}\n\n.bg-light-pink { background-color: #fddefd !important; }\n.bg-medium-pink { background-color: #fd78ff !important; }\n.bg-dark-pink { background-color: #d354f3 !important; }\n.bg-very-dark-pink { background-color: #84369c !important; }\n.nc-text-primary { background-color: rgba(233, 146, 255, 0.7); color: black; }\n.nc-text-secondary { color: white; }\n.nav-link-text { color: rgb(0, 59, 18) !important; }\n.nc-background { background-image: linear-gradient(270deg, #cd89da 0%, #c555bc 70%) !important; }\n.section { scroll-margin-top: 100px; }\n.first-section { scroll-margin-top: 130px; }\n.first-section-margin-bottom { margin-bottom: 1300px;}\n.show-description { display: none !important; }\n.nc-event {background-color: #d354f3 !important; font-size: 12px !important; color: white;}\n.nc-event h4 {font-size: 12px !important; color: white;}\n.nc-event a:visited { color: black; }\n.nc-event a:active { color: black;}\n.carousel-img { max-height: 200px; max-width: 100%; width: auto !important; display: inline !important; }\n.item {text-align: center;}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
